require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/es7.symbol.async-iterator.js